import React from 'react'
import { useAuth } from '../../contexts/AuthContext'
import { useFeatureFlags } from '../../contexts/FeatureFlagContext'

/** Renders children when Dynamic Forms is enabled and the user can view forms. */
export default function FormsModuleGate({ children }) {
  const { can } = useAuth()
  const { isPageEnabled } = useFeatureFlags()
  if (!isPageEnabled('/compliance-safe/forms')) return null
  if (!can('compliance-safe/forms', 'view') && !can('admin/form-builder', 'view')) return null
  return children
}
